import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { getThumbnailOffenders } from "../../api/getThumbnailOffenders";

interface ThumbnailOffendersBannerProps {
  entityType?: "resource" | "event";
}

const ThumbnailOffendersBanner: React.FC<ThumbnailOffendersBannerProps> = ({
  entityType,
}) => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let active = true;
    getThumbnailOffenders({ entityType })
      .then((response) => {
        if (active) {
          setCount(response.data.offenders.length);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });
    return () => {
      active = false;
    };
  }, [entityType]);

  if (loading || count === 0) {
    return null;
  }

  return (
    <Alert className="mb-4" variant="default">
      <ExclamationTriangleIcon className="h-4 w-4" />
      <AlertDescription className="flex flex-wrap items-center gap-x-2">
        <span>
          {count} {entityType ? `${entityType} ` : ""}image
          {count === 1 ? "" : "s"} don&apos;t meet the required 16:9 / ≥1280×720
          spec.
        </span>
        <Link
          className="font-medium text-primary underline-offset-4 hover:underline"
          to="/admin/image-remediation"
        >
          Review &amp; fix
        </Link>
      </AlertDescription>
    </Alert>
  );
};

export default ThumbnailOffendersBanner;
